import styled from 'styled-components';

export const StyledSpinner = styled.div`
  width: ${({ $width }) => `${$width / 10}rem` || '4rem'};
  height: ${({ $height }) => `${$height / 10}rem` || '4rem'};
  display: flex;
`;
